// The string below is a marker and will be replaced by the real version number. DO NOT CHANGE
export var VERSION = 'react-' + '2.5.0';
// Treatments
export var ON = 'on';
export var OFF = 'off';
export var CONTROL = 'control'; // SplitIO default value
export var CONTROL_WITH_CONFIG = {
    treatment: 'control',
    config: null,
};
// Warning and error messages
export var WARN_SF_CONFIG_AND_FACTORY = '[WARN]  Both a config and factory props were provided to SplitFactoryProvider. Config prop will be ignored.';
export var EXCEPTION_NO_SFP = 'No SplitContext was set. Please ensure the component is wrapped in a SplitFactoryProvider.';
export var WARN_NAMES_AND_FLAGSETS = '[WARN]  Both names and flagSets properties were provided. flagSets will be ignored.';
